/**
 * «Is there a string for this key?» — asked by translating it. vue-i18n's `te()` walks a key as a NESTED path, and our
 * messages are FLAT dotted keys («vitrine.error.X»), so `te()` answers «no» for every one of them: the top-up screen
 * fell back to its neutral line on prod, the key sheet printed «ETHEREUM_HEX», the terms card always said
 * «unavailable». `t()` returns the key itself when nothing is found — that is the check. One copy for every screen.
 */
type Translate = (key: string) => string;

export function hasMessage(t: Translate, key: string): boolean {
  return !!key && t(key) !== key;
}

/** The translation of `key`, or `fallback` when the cabinet has no string for it. */
export function translatedOr(t: Translate, key: string, fallback: string): string {
  if (!key) return fallback;
  const text = t(key);
  return text !== key ? text : fallback;
}
